// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__T0X4M","errorLogs":"EditorFooter_errorLogs__2osAS"};